<template>
    <VDialog v-model="show" width="1200" @update:model-value="toggle">
        <template v-slot:activator="{props: activatorProps}">
            <ServiceTipsIcon v-bind="activatorProps" :class="activatorClass" />
        </template>
        <OrderDetailsTips :tips="tips" :loaded="loaded" show-close @close="show = false" />
    </VDialog>
</template>

<script setup lang="ts">
    import ServiceTipsIcon from '~src/components/account/orderServices/ServiceTipsIcon.vue'
    import OrderDetailsTips from '~/components/account/OrderDetailsTips.vue'

    const props = defineProps<{
        offerKey: string
        activatorClass?: string
    }>()

    const app = useNuxtApp()

    const show = ref(false)
    const loaded = ref(false)
    const tips = ref([])

    async function toggle() {
        if (show.value && !loaded.value) {
            try {
                tips.value = (await app.$api.tips.get({offerKeys: props.offerKey})).tips
                loaded.value = true
            } catch (e: any) {
                if (e.status === 404) EventBus.$emit('OFFER_EXPIRED_EVENT')
                app.$toast.error(app.$i18n.t('error_message.load_error'))
            }
        }
    }
</script>
